import Serializer from 'umg-ember-backend/serializers/application';

export default class ActionSerializer extends Serializer {
  attrs = {
    asset: 'assetId',
  };
}
